module.exports = __webpack_public_path__ + "static/media/illustration.1a4d190c.png";